export function normalizeMerchantTaxSettings(settings = {}) {
  return {
    enabled: settings.enabled === true,
    rate: Number(settings.rate || 0),
    name: settings.name || 'Tax',
    inclusive: settings.inclusive === true
  };
}

export function calculateMerchantTaxAmount(baseAmount, settings = {}) {
  const config = normalizeMerchantTaxSettings(settings);
  const base = Number(baseAmount || 0);
  if (!config.enabled || config.rate <= 0 || base <= 0) return 0;

  const multiplier = config.rate / 100;
  const amount = config.inclusive
    ? base - (base / (1 + multiplier))
    : base * multiplier;

  return Math.round(amount * 100) / 100;
}

export function calculateMerchantTaxTotal(baseAmount, settings = {}) {
  const config = normalizeMerchantTaxSettings(settings);
  const taxAmount = calculateMerchantTaxAmount(baseAmount, config);
  return config.inclusive ? Number(baseAmount || 0) : Number(baseAmount || 0) + taxAmount;
}

export function calculateMerchantTaxAmountToAdd(baseAmount, settings = {}) {
  const config = normalizeMerchantTaxSettings(settings);
  if (config.inclusive) return 0;
  return calculateMerchantTaxAmount(baseAmount, config);
}

export function getOrderTaxName(order = {}) {
  return order.taxName
    || order.taxSettings?.name
    || order.metadata?.taxSettings?.name
    || 'Tax';
}

export function getQuoteTaxInfo(quote = {}) {
  const settings = quote.taxSettings || quote.metadata?.taxSettings || {};
  const amount = Number(
    quote.taxAmount
    ?? quote.taxTotal
    ?? quote.tax
    ?? 0
  ) || 0;
  const enabled = quote.taxEnabled === true
    || settings.enabled === true
    || amount > 0;

  return {
    enabled,
    amount,
    name: quote.taxName || settings.name || 'Tax',
    rate: Number(quote.taxRate ?? settings.rate ?? 0) || 0,
    inclusive: quote.taxInclusive === true || settings.inclusive === true
  };
}
